<script>
import AdvancedSettingsPanels from '@v/settings/application/advanced/AdvancedSettingsPanels.vue'

export default {
  name: 'ResourceAdvancedSettingsTab',
  functional: true,
  render: (h, { props }) => h(AdvancedSettingsPanels, { props }),
}
</script>
